export const AssignmentsStatusFilters = ['Currently assigned', 'Completed'];
export const TablesStatusFilters = [
  'Not Started',
  'In progress',
  'Awaiting approval',
];
export const mapStatusByName = {
  'Not Started': 'Not_Started',
  'In progress': 'In_Progress',
  Submitted: 'Submitted',
  Completed: 'Completed',
  Published: 'Published',
};
export const getStatusByName = (status) => mapStatusByName[status];
export const WritersTableStatusFilters = ['Working On', 'Awaiting approval'];
export const getStatusesForWritersFilter = (filter) => {
  if (filter === 'Working On') {
    return [mapStatusByName['Not Started'], mapStatusByName['In progress']];
  }
  if (filter === 'Awaiting approval') {
    return [mapStatusByName.Submitted];
  }
  return [getStatusByName(filter)];
};
